import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
//import {BrowserDomAdapter} from '@angular/platform-browser/src/browser/browser_adapter';
import {SharedService} from '../shared/shared.service';
import {Router, ActivatedRoute} from '@angular/router';
import {AfterViewInit} from '@angular/core';
import { NavbarService } from '../navbar/navbar.service';

declare var UserInterface: any;
declare var HWV_CSR: any;
declare var unload: any;
declare var killPreviousViewer: any;
declare var loadtwoViews: any;
declare var JsonViewerDataMrc: any;
declare var twoViewFunction: any;
declare var destroyHWVViewers: any;

declare var getcurrentLoadedFiles: any;

@Component({
  // moduleId: module.id,
  selector: 'compareview',
  templateUrl: 'compareview.component.html',
  styleUrls: ['compareview.component.css'],
  encapsulation: ViewEncapsulation.Emulated
})
export class CompareviewComponent implements OnInit, AfterViewInit {

  hwv1: any;
  hwv2: any;
  userInterface: any;
  twoViewFunction: any;
  _service: any;
  hwfurl: string;
  private file: string;
  isvalid: boolean = true;
  tenantid: string = '';

  constructor(private  service: SharedService,
              private router: Router,
              private route: ActivatedRoute,
              public navService: NavbarService) {
                this._service = service;
              }


  ngOnInit() {
    this.navService.hide();
    console.log('In Viewer Component. URL:', this.router.url);

    this.tenantid = localStorage.getItem('mr_tenantid');
  }

  ngAfterViewInit() {
    console.log('In ngAfterViewInit Component');
    this.loadsaperateviews();
    this.loadsuperimposeview();
  }

  ngOnDestroy() {
    new destroyHWVViewers();
  }

  loadsaperateviews() {
    console.log('loadsaperateviews Called');
    this.hwv1 = new HWV_CSR('canvas1');
    this.hwv2 = new HWV_CSR('canvas2');
    this.twoViewFunction = new twoViewFunction(this.hwv1, this.hwv2);
  }

  loadsuperimposeview() {
    console.log('loadsuperimposeview Called');
    let urls = getcurrentLoadedFiles();
    console.log('urls Called = ' + urls);
    this._service.saveData(urls);
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/compareview/compareview.component.ts